module.exports = __webpack_public_path__ + "static/media/totok-wajah.7dd1be6e.webp";